import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const MuteIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <g clipPath="url(#clip0_10711_55312)">
            <path
               d="M1.45128 2.09136C1.06129 1.78387 0.495046 1.85511 0.187551 2.24511C-0.119943 2.6351 -0.0486947 3.20134 0.341298 3.50884L22.5409 20.9085C22.9309 21.216 23.4971 21.1448 23.8046 20.7548C24.1121 20.3648 24.0409 19.7986 23.6509 19.4911L20.3509 16.9036C21.8509 15.5874 22.7959 13.6524 22.7959 11.4999C22.7959 9.24623 21.7572 7.23252 20.1372 5.91254C19.751 5.59755 19.1847 5.65755 18.8697 6.04379C18.5547 6.43003 18.6147 6.99627 19.001 7.31127C20.2197 8.30125 20.9959 9.80872 20.9959 11.4999C20.9959 13.1912 20.2197 14.6986 19.001 15.6924C18.9672 15.7186 18.9372 15.7486 18.911 15.7749L17.276 14.4924C17.4822 14.4961 17.6922 14.4324 17.8647 14.2899C18.6747 13.6337 19.196 12.6287 19.196 11.4999C19.196 10.3712 18.6747 9.36623 17.8685 8.70624C17.4822 8.39125 16.916 8.45125 16.601 8.83749C16.286 9.22374 16.346 9.78998 16.7323 10.105C17.1373 10.435 17.396 10.9375 17.396 11.4999C17.396 12.0624 17.1373 12.5649 16.7323 12.8987C16.4473 13.1312 16.3423 13.4987 16.4323 13.8324L14.3961 12.2387V4.21757C14.3961 3.59883 13.8973 3.10009 13.2786 3.10009C13.0048 3.10009 12.7423 3.20134 12.5361 3.38134L8.11491 7.31502L1.45128 2.09136ZM9.55489 8.44375L12.5961 5.7363V10.825L9.55489 8.44V8.44375ZM4.49623 9.69998H5.32871L3.41999 8.19625C2.80501 8.56375 2.39626 9.23498 2.39626 9.99997V12.9999C2.39626 14.1586 3.3375 15.0999 4.49623 15.0999H7.45492L12.5361 19.6186C12.7423 19.7986 13.0048 19.8998 13.2786 19.8998C13.8973 19.8998 14.3961 19.4011 14.3961 18.7823V16.8436L12.5961 15.4261V17.2598L8.39241 13.5287C8.22741 13.3824 8.01366 13.2999 7.79617 13.2999H4.49623C4.33123 13.2999 4.19623 13.1649 4.19623 12.9999V9.99997C4.19623 9.83497 4.33123 9.69998 4.49623 9.69998Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_10711_55312">
               <rect
                  width="24"
                  height="24"
                  fill="white"
               />
            </clipPath>
         </defs>
      </svg>
   )
}

export default MuteIcon
